import { useState, Fragment, memo } from "react";
import SelectSwiper from './SelectSwiper'
import { useAuthModal } from "core/context";
import { useGetImagePicker } from "core/hooks/useImagePicker";

type TAddImageSwiperButton = {
  className?: string,
  children: React.ReactNode
}

const AddImageSwiperButton = ({
  className,
  children,
}: TAddImageSwiperButton) => {
  const { openModal, token } = useAuthModal();
  const [ isDrawerOpen, setIsDrawerOpen ] = useState<boolean>(false);
  const communityImages = useGetImagePicker('communityImages', true)

  const toggleDrawer = () => {
    if (!token) {
      openModal(() => {
        document.getElementById('AddImageSwiperButton')?.click()
      });
      return;
    }
    setIsDrawerOpen((prev: boolean) => !prev);
  }

  return (
    <Fragment>
      <div
        className={`${communityImages?.length >= 10 ? ' hidden' : ''} ${className}`}
        onClick={toggleDrawer}
        id={'AddImageSwiperButton'}
      >
        {children}
      </div>
      
      <SelectSwiper
        isDrawerOpen={isDrawerOpen}
        setIsDrawerOpen={setIsDrawerOpen}
      />
    </Fragment>
  )
}

export default memo(AddImageSwiperButton)
